import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, FormLabel, Grid, InputAdornment } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Notification from '../../../components/Common/Notification';
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";

import { connect, useDispatch } from 'react-redux';
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import { createShippingRate, getGeneral, getShippingDetails, getShippingListing, getShippingRateDetails, resetShippingRateState, updateShippingRate } from "../../../store/actions";
import LoadingDialog from "../../../components/Common/LoadingDialog";



const AddShippingRateRate = ({ type, title, shippingAdd, editShippingRate, addShippingRate, shippingDetails, shipping_type }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef();
    const [loading, setIsLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    useEffect(() => {
        dispatch(resetShippingRateState())

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                dispatch(getShippingRateDetails({ id: ID }))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                const filtered = shippingDetails || []
                if (filtered) {
                    setFormValues({
                        shipping_method_id: filtered?.descriptions?.[0]?.shipping_method_id,
                        title: filtered?.descriptions?.[0]?.title,
                        type: filtered?.descriptions?.[0].type || "",
                        min_order_amount: filtered?.descriptions?.[0].min_order_amount || "",
                        max_order_amount: filtered?.descriptions?.[0].max_order_amount || "",
                        min_weight_range: filtered?.descriptions?.[0].min_weight_range || "",
                        max_weight_range: filtered?.descriptions?.[0].max_weight_range,
                        price: filtered?.descriptions?.[0].price,
                        status: filtered.status,
                        sort_order: filtered.sort_order,
                    })
                }
            }
        }
    }, [shippingDetails]);

    useEffect(() => {
        if (type === "Edit") {
            if (editShippingRate?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Updated Successfully",
                    type: "success",
                })
                dispatch(resetShippingRateState());
                dispatch(getGeneral());
                dispatch(getShippingRateDetails({ id: ID }))
            }
        }
    }, [editShippingRate]);

    useEffect(() => {
        if (type === "Add") {
            if (addShippingRate?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Added Successfully",
                    type: "success",
                })
                dispatch(resetShippingRateState())
                dispatch(getGeneral());
                navigate("/settings-shipping-rates")
            } else if (addShippingRate?.[0]?.address) {
                setNotification({
                    open: true,
                    msg: addShippingRate?.[0]?.address,
                    type: "warning",
                })
            }
        }
    }, [addShippingRate]);

    const handleSubmit = (type) => {
        if (type === "Add") {
            dispatch(createShippingRate(values))
        }
        else if (type === "Edit") {
            dispatch(updateShippingRate({ id: ID, shippingRate: values }))
        }

    }

    const defaultValues = {
        shipping_method_id: "",
        title: "",
        type: "",
        min_order_amount: "",
        max_order_amount: "",
        min_weight_range: "",
        max_weight_range: "",
        price: "",
        status: "1",
        sort_order: "",
    }

    const { ID } = useParams()

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [values, setFormValues] = useState(defaultValues);
    const data = [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]

    const error = shippingAdd?.[0];

    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={type === 'Add' ? 'Save' : 'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || !shippingDetails} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/settings-shipping-rates"}
                        breadcrumbItems={[{ title: "Shipping Rates", link: "/settings-shipping-rates" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={type === 'Add' ? 'Save' : 'Save Changes'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    {/* <Card className="p-3">
                        <CardBody> */}
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} pb={3}>
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <CustomSelect
                                                title={'Shipping method'}
                                                values={values?.shipping_method_id || '-1'}
                                                placeholder={'Please Select'}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    shipping_method_id: e
                                                }))}
                                                valueName={"id"}
                                                labelName={"title"}
                                                data={shipping_type}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.shipping_method_id || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Rate name'}
                                                values={values?.title}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    title: e
                                                }))}
                                                placeholder={'E.g. Ground shipping '}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.title || ""}</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>
                            <Card className="p-3 px-2 mt-3">
                                <CardBody>
                                    <div className="setting-header">CONDITIONS (OPTIONAL)</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Order amount range </FormLabel>
                                            <div className="d-flex align-items-center">
                                                <CustomTextField
                                                    values={values?.min_order_amount}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        min_order_amount: e
                                                    }))}
                                                    type={'number'}
                                                    placeholder={'0.00'}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start"><span style={{ color: '#999999' }}>S$</span></InputAdornment>,
                                                    }}
                                                />
                                                <div className="mx-2"> - </div>
                                                <CustomTextField
                                                    values={values?.max_order_amount}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        max_order_amount: e
                                                    }))}
                                                    type={'number'}
                                                    placeholder={'0.00'}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start"><span style={{ color: '#999999' }}>S$</span></InputAdornment>,
                                                    }}
                                                />
                                            </div>

                                            {error && <FormHelperText sx={{ color: "red" }}>{error.description || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Weight range</FormLabel>
                                            <div className="d-flex align-items-center">
                                                <CustomTextField
                                                    values={values?.min_weight_range}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        min_weight_range: e
                                                    }))}
                                                    type={'number'}
                                                    placeholder={'0.00'}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end"><span style={{ color: '#999999' }}>kg</span></InputAdornment>,
                                                    }}
                                                />
                                                <div className="mx-2"> - </div>
                                                <CustomTextField
                                                    values={values?.max_weight_range}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        max_weight_range: e
                                                    }))}
                                                    type={'number'}
                                                    placeholder={'0.00'}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end"><span style={{ color: '#999999' }}>kg</span></InputAdornment>,
                                                    }}
                                                />
                                            </div>

                                            {error?.max_weight_range?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error?.max_weight_range[0] || ""}</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>
                            <Card className="p-3 px-2 mt-3">
                                <CardBody>
                                    <div className="setting-header">PRICING</div>
                                    <Divider className="my-2 mb-4" />
                                    <CustomTextField
                                        title={'Shipping cost'}
                                        values={values?.price}
                                        onChange={(e) => setFormValues((prevValues) => ({
                                            ...prevValues,
                                            price: e
                                        }))}
                                        type={'number'}
                                        placeholder="0.00"
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><span style={{ color: '#999999' }}>S$</span></InputAdornment>,
                                        }}
                                    />
                                    {error && <FormHelperText sx={{ color: "red" }}>{error.price || ""}</FormHelperText>}
                                </CardBody>
                            </Card>
                        </Grid>
                        <Grid container item sm={12} lg={type === 'add' ? 12 : 4}>
                            <Grid item xs={12} sm={12}>
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />
                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title={'Status'}
                                                value={parseInt(values?.status)}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    status: e,
                                                }))}
                                                required="true"
                                                name="status"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                                        </div>
                                        <div className="mt-3">
                                            <CustomTextField
                                                title={'Sort order'}
                                                values={values?.sort_order}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    sort_order: e
                                                }))}
                                                error={error && error?.sort_order}
                                                type={'phone'}
                                                placeholder={'0'}
                                            />
                                        </div>
                                        {/* {
                                            type === 'Edit' &&
                                            <>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Last modified</FormLabel>
                                                <div>10 Oct 2024, 03:14 PM</div>
                                            </>
                                        } */}
                                    </CardBody>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                    {/* </CardBody>
                    </Card> */}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, ShippingRate, Shipping }) {
    const shippingMethodList = General.shipping_methods?.length > 0 ? General.shipping_methods?.filter((item) => item?.status === 1) : [];
    return {
        shipping_type: General.shipping_methods,
        shippingDetails: ShippingRate.shippingRateDetails,
        shippingAdd: ShippingRate.error,
        addShippingRate: ShippingRate.addShippingRate,
        editShippingRate: ShippingRate.updateShippingRate,
        country: General.countries,
        shippingMethodDropdown: Shipping.shippingListing,
        countryWithoutMlys: General.countries.filter((el) => el.id != 129),
    };
}


export default connect(mapStateToProps)(AddShippingRateRate);
